import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';

export const accessories: tCaseComponentsLib = [
    // {
    //     id: '733fa0ab-7cd4-4d3c-87f8-44700d3e1e08',
    //     name: 'Полка малая SSh',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    {
        id: 'sh_lar_lsh',
        name: 'Полка большая LSh',
        type: 'accessory',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_large_lsh',
        image: 'dist/src/img/sh_lar_lsh.png',
        xmlId: 'ae2a5625-47ff-5fdc-8dc8-c94108e5c2e3',
    },
    // {
    //     id: 'ef40c602-22a9-40fa-a3fd-a293ac371fd2',
    //     name: 'Полка для баллончиков ScSh',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    {
        id: 'tray_hol_a4',
        name: 'Лоток держатель А4',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'tray_holder_a4',
        image: 'dist/src/img/tray_hol_a4.png',
        xmlId: '95e7ca8e-dff5-1e79-cb66-0e22711a0e19',
    },
    {
        id: 'wh_key_hol',
        name: 'Держатель ключей WH',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'wh_key_holder',
        image: 'dist/src/img/wh_key_hol.png',
        xmlId: 'f0b3c549-c04f-e901-626c-0866b62627de',
    },
    {
        id: 'pap_towel_pth',
        name: 'Держатель для бумажных полотенец PTH',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'paper_towel_holder_pth',
        image: 'dist/src/img/pap_towel_pth.png',
        xmlId: '0b2ba6b8-fcb4-b437-f665-9f22a7451e6e',
    },
    {
        id: 'ushm_hol',
        name: 'Держатель для болгарки D-125',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'ushm_holder',
        image: 'dist/src/img/ushm_hol.png',
        xmlId: '0b20ff12-b784-2f38-8ef8-d0d3d08a011e',
    },
    {
        id: 'box_hol_200_SPBH',
        name: 'Держатель для пластикового ящика 200 SPBH',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'plastic_box_holder_200_SPBH',
        image: 'dist/src/img/box_hol_200_SPBH.png',
        xmlId: 'bc2ba689-36b7-545d-c566-e11495eb0b6b',
    },
    // {
    //     id: '82ea4f48-798c-4c96-af77-213f162556d9',
    //     name: 'Держатель для сверл DH',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    {
        id: 'hexagon_hh',
        name: 'Держатель для шестигранников HH',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'hexagon_holder_hh',
        image: 'dist/src/img/hexagon_hh.png',
        xmlId: '61d77ae8-d31b-1d82-528f-f12fc9e3bcf7',
    },
    // {
    //     id: 'c4c8ae0c-8121-46e1-b894-9085a98c3e82',
    //     name: 'Держатель инструмента TH',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '0864f395-8a56-40a9-ae48-2400845f03f0',
    //     name: 'Держатель для торцевых головок 1/2 HeC',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '03fb48b7-5661-4a52-9262-18282f05864f',
    //     name: 'Держатель для пластикового ящика 1000 LPBH',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '064da908-e23b-4121-929b-8731a6634294',
    //     name: 'Крючок HK 80',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    {
        id: 'hook_hk_2_80',
        name: 'Крючок HK 2-80',
        type: 'accessory',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
        blenderName: 'hook_hk_2_80',
        image: 'dist/src/img/hook_hk_2_80.png',
        xmlId: '6c64a78c-0fb0-193b-af80-2ccdd2858710',
    },
    // {
    //     id: 'd8af77b3-a2d2-4260-bf9c-8a51fbce1576',
    //     name: 'Крючок HK 120',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '19b2bfad-c529-408b-bd1c-f8fe74984d67',
    //     name: 'Крючок HK 4',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '5d44f8a1-db98-41c2-9905-bfeacf46984a',
    //     name: 'Крючок-держатель HK 5',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '59c86402-56ec-42b4-bde5-4a52d62092f5',
    //     name: 'Крючок HKO',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '4fe4b25d-1360-459d-b488-80dd35410533',
    //     name: 'Ящик пластиковый Практик 100х105х45 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '101e49b1-dcf6-43d9-bb0e-375ccc32d088',
    //     name: 'Ящик пластиковый Практик 150х105х75 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '512bdfe9-1fb5-4e5e-8831-4e338df07db7',
    //     name: 'Ящик пластиковый Практик 170x105x80 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: 'e62f4ced-5843-4781-82a6-c25e1285d16d',
    //     name: 'Ящик пластиковый Практик 200x157x90 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: 'c64d59f1-682a-4fbb-8e0e-d3599c153639',
    //     name: 'Ящик пластиковый Практик 250х230х150 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '367a0fa2-46a8-4edf-a56c-be830b288935',
    //     name: 'Ящик пластиковый Практик 300х230х150 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '668ebc7a-ac75-40c1-acba-101ab9a3608d',
    //     name: 'Ящик пластиковый Практик 350х230х150 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    // {
    //     id: '4785990c-d1b6-475c-92c7-0ff4a57bb2ee',
    //     name: 'Ящик пластиковый Практик 400x185x100 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
    //TODO (пока что) Пластиковый ящик из аксессуаров скрыть для всех вариантов шкафа
    // {
    //     id: 'plas_box_400x230x150',
    //     name: 'Ящик пластиковый Практик 400x230x150 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: 'plastic_box_400x230x150',
    //     image: 'dist/src/img/plas_box_400x230x150.png',
    //     xmlId: 'd7848519-5fc8-e387-e641-67735c09fd46',
    // },

    // {
    //     id: '21ee16e1-7f6b-47cc-84b8-890ffd678764',
    //     name: 'Ящик пластиковый Практик 500x230x150 синий',
    //     type: 'accessory',
    //     caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947', 'AMH-TC', 'AMH-TC-EL', 'HARD-1000', 'HARD-2000' ],
    //     blenderName: '',
    //     image: '',
    //     xmlId: '',
    // },
];
